import { make } from 'vuex-pathify'

export const state = () => ({
  consumer: null,
  selected: null,
  query: null,
})

export const mutations = make.mutations(state)
